import { createContext } from "react";
import { LocalStorageContextType } from "./type";

export const LocalStorageContext = createContext<
  LocalStorageContextType | undefined
>(undefined);
